import { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import "../campus/Campus.css";
import {
  Typography,
  Checkbox,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
import CircularProgress from "@mui/material/CircularProgress";
import Select from "react-select";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const BulkMeritList = () => {
  const [showMeritModal, setShowMeritModal] = useState(false);
  const [meritModalData, setMeritModalData] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [departments, setDepartments] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState("");
  const [selectedProgramName, setSelectedProgramName] = useState("");
  const [quotas, setQuotas] = useState([]);
  const [selectedQuotas, setSelectedQuotas] = useState([]); // Changed to array for multiple selection
  // Per-quota editable values
  const [quotaDetails, setQuotaDetails] = useState({});
  const [generatedMeritList, setGeneratedMeritList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [lastDate, setLastDate] = useState("");
  const [errors, setErrors] = useState({});
  const [meritListTypes, setMeritListTypes] = useState([]);
  const [selectedMeritListType, setSelectedMeritListType] = useState("");
  const [programCriteriaId, setProgramCriteriaId] = useState("");
  const [merit_lists_templates, setMeritListsTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [multiplier, setMultiplier] = useState(1);
  const [wantToInclude, setWantToInclude] = useState("both");
  const [groupedDegrees, setGroupedDegrees] = useState([]);

  // Add loading states for various operations
  const [campaignsLoading, setCampaignsLoading] = useState(false);
  const [departmentsLoading, setDepartmentsLoading] = useState(false);
  const [programsLoading, setProgramsLoading] = useState(false);
  const [quotasLoading, setQuotasLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const getAllCampaigns = async () => {
    setCampaignsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/campaign/get_campaigns`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        setCampaigns(data.campaigns);
      } else {
        toast.error(data.error || "Failed to fetch campaigns");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch campaigns");
    } finally {
      setCampaignsLoading(false);
    }
  };

  const getDepartments = async () => {
    setDepartmentsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/department/get_departments`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        setDepartments(data.departments);
      } else {
        toast.error(data.error || "Failed to fetch departments");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch departments");
    } finally {
      setDepartmentsLoading(false);
    }
  };

  const getTemplates = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/application/get_merit_list_templates`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (response.ok) {
        setMeritListsTemplates(data.templates);
      } else {
        toast.error(data.error || "Failed to fetch templates");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch templates");
    }
  };

  const getDegreesByDepartments = async (department_id) => {
    setProgramsLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/degree/get_grouped_degrees_by_department/${department_id}?campaign_id=${selectedCampaign}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (response.ok) {
        setPrograms(data.grouped_degrees);
        setGroupedDegrees(data.grouped_degrees);
      } else {
        toast.error(data.error || "Failed to fetch programs");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch programs");
    } finally {
      setProgramsLoading(false);
    }
  };

  const getQuotas = async () => {
    setQuotasLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/quota/get_quotas`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        setQuotas(data.quotas);
      } else {
        toast.error(data.error || "Failed to fetch quotas");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch quotas");
    } finally {
      setQuotasLoading(false);
    }
  };

  const handleDepartmentChange = (option) => {
    const departmentId = option?.id;
    setSelectedDepartment(departmentId);
    if (departmentId) {
      getDegreesByDepartments(departmentId);
    }
  };

  const handleProgramChange = (option) => {
    const programId = option?.id || null;
    setSelectedProgram(programId);
    setSelectedProgramName(option?.name || "");
    const selectedProgramObj = programs.find((p) => p.id === programId);
    const sessions = selectedProgramObj?.sessions || [];
    setMeritListTypes(sessions);
  };

  // Handle quota selection/deselection
  const handleQuotaChange = (quota, isChecked) => {
    if (isChecked) {
      setSelectedQuotas((prev) => [...prev, quota]);
      setQuotaDetails((prev) => ({
        ...prev,
        [quota.id]: {
          lastDate: lastDate,
          template: selectedTemplate,
          meritListType: selectedMeritListType,
          multiplier: multiplier,
          wantToInclude: wantToInclude,
        },
      }));
    } else {
      setSelectedQuotas((prev) => prev.filter((q) => q.id !== quota.id));
      setQuotaDetails((prev) => {
        const copy = { ...prev };
        delete copy[quota.id];
        return copy;
      });
    }
  };

  // Handle select all quotas
  const handleSelectAllQuotas = (isChecked) => {
    if (isChecked) {
      setSelectedQuotas([...quotas]);
      // Set details for all quotas
      const details = {};
      quotas.forEach((quota) => {
        details[quota.id] = {
          lastDate: lastDate,
          template: selectedTemplate,
          meritListType: selectedMeritListType,
          multiplier: multiplier,
          wantToInclude: wantToInclude,
        };
      });
      setQuotaDetails(details);
    } else {
      setSelectedQuotas([]);
      setQuotaDetails({});
    }
  };

  // Check if a quota is selected
  const isQuotaSelected = (quotaId) => {
    return selectedQuotas.some((q) => q.id === quotaId);
  };

  // Handle per-quota field change
  const handleQuotaFieldChange = (quotaId, field, value) => {
    setQuotaDetails((prev) => ({
      ...prev,
      [quotaId]: {
        ...prev[quotaId],
        [field]: value,
      },
    }));
  };

  // Check if all quotas are selected
  const areAllQuotasSelected = () => {
    return quotas.length > 0 && selectedQuotas.length === quotas.length;
  };

  // Enhanced validation for merit list creation
  const validate = () => {
    const errors = {};
    // Removed validation for name field

    if (!lastDate) {
      errors.lastDate = "Last Date is required";
    } else {
      const selectedDate = new Date(lastDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (selectedDate < today) {
        errors.lastDate = "Last Date cannot be in the past";
      }
    }

    if (!selectedCampaign) {
      errors.campaign = "Campaign is required";
    }

    if (!selectedDepartment) {
      errors.department = "Department is required";
    }

    if (!selectedProgram) {
      errors.program = "Program is required";
    }

    if (!selectedQuotas || selectedQuotas.length === 0) {
      errors.quotas = "At least one quota is required";
    }

    if (!selectedMeritListType) {
      errors.meritListType = "Merit List Type is required";
    }

    if (!selectedTemplate) {
      errors.templates = "Template is required";
    }

    if (!multiplier || multiplier <= 0) {
      errors.multiplier = "Multiplier must be greater than 0";
    }

    if (!wantToInclude) {
      errors.wantToInclude = "Want to Include is required";
    }

    return errors;
  };

  const handleGenerateMeritList = async () => {
    const errors = validate();
    console.log(errors);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      toast.error("Please fix all validation errors");
      return;
    }

    setLoading(true);
    // Build merit_list_requests array from selectedQuotas and quotaDetails
    const merit_list_requests = selectedQuotas.map((quota) => {
      const details = quotaDetails[quota.id] || {};
      return {
        campaign_id: selectedCampaign,
        department_id: selectedDepartment,
        program_ids: Array.isArray(selectedProgram)
          ? selectedProgram
          : [selectedProgram],
        program_name: selectedProgramName,
        program_criteria_id: programCriteriaId,
        quota_id: quota.id,
        template_id: details.template || selectedTemplate,
        multiplier: details.multiplier || multiplier,
        want_to_include: details.wantToInclude || wantToInclude,
        merit_list_type: details.meritListType || selectedMeritListType,
        last_date: details.lastDate || lastDate,
      };
    });

    try {
      const response = await fetch(
        `${BASE_URL}/application/generate_bulk_merit_lists`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ merit_list_requests }),
        }
      );

      const data = await response.json();
      if (response.ok && data.success && Array.isArray(data.merit_lists)) {
        setMeritModalData(data.merit_lists);
        setShowMeritModal(true);
        toast.success("Merit list generated successfully");
      } else if (response.ok && data.merit_list) {
        setGeneratedMeritList(data.merit_list);
        toast.success("Merit list generated successfully");
      } else {
        toast.error(data.error || "Failed to generate merit list");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate merit list");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    if (generatedMeritList.length === 0) {
      toast.error("Please generate merit list first");
      return;
    }

    setSaveLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/application/add_merit_list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name,
          last_date: lastDate,
          campaign_id: selectedCampaign,
          department_id: selectedDepartment,
          program_ids: selectedProgram,
          merit_list_type: selectedMeritListType,
          program_criteria_id: programCriteriaId,
          quota_ids: selectedQuotas.map((q) => q.id), // Send array of quota IDs
          template_id: selectedTemplate,
          multiplier: multiplier,
          want_to_include: wantToInclude,
          merit_list_applications: generatedMeritList,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(data.success || "Merit list saved successfully");
        // Reset form after successful save
        setName("");
        setLastDate("");
        setSelectedCampaign("");
        setSelectedDepartment("");
        setSelectedProgram("");
        setSelectedQuotas([]);
        setSelectedMeritListType("");
        setSelectedTemplate("");
        setMultiplier(1);
        setWantToInclude("both");
        setGeneratedMeritList([]);
        setErrors({});
        setMeritListTypes([]);
      } else {
        toast.error(data.error || "Failed to save merit list");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to save merit list");
    } finally {
      setSaveLoading(false);
    }
  };

  const handleReset = () => {
    setName("");
    setLastDate("");
    setSelectedCampaign("");
    setSelectedDepartment("");
    setSelectedProgram("");
    setSelectedQuotas([]);
    setSelectedMeritListType("");
    setSelectedTemplate("");
    setMultiplier(1);
    setWantToInclude("both");
    setGeneratedMeritList([]);
    setErrors({});
    setMeritListTypes([]);
  };

  useEffect(() => {
    getAllCampaigns();
    getDepartments();
    getTemplates();
    getQuotas();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      {/* Modal for merit lists */}
      <Modal
        open={showMeritModal}
        onClose={() => setShowMeritModal(false)}
        aria-labelledby="merit-list-modal-title"
        aria-describedby="merit-list-modal-desc"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: '98vw',
            maxWidth: 700,
            maxHeight: '90vh',
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 4,
            p: 5,
            overflowY: 'auto',
          }}
        >
          <Typography id="merit-list-modal-title" variant="h6" component="h2" sx={{ mb: 3, textAlign: 'center', fontWeight: 700 }}>
            Generated Merit Lists
          </Typography>
          {meritModalData.length > 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxHeight: '55vh', overflowY: 'auto', pr: 1 }}>
              {meritModalData.map((ml, idx) => (
                <Box key={idx} sx={{
                  p: 2,
                  border: "1px solid #e3e6ef",
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                  background: '#f8fafc',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  minHeight: 70,
                }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: 18, color: '#222', mb: 0.5 }}>
                    {ml.name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#1976d2", fontSize: 16 }}>
                    Count: <span style={{ fontWeight: 600 }}>{ml.count}</span>
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Typography>No merit lists found.</Typography>
          )}
          <Box sx={{ textAlign: "right", mt: 3 }}>
            <Button variant="contained" style={{color: "white"}} onClick={() => setShowMeritModal(false)} sx={{ fontWeight: 600, px: 3, py: 1 }}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card className="mt-5 card1">
              <MDBox
                mx={0}
                mt={0}
                py={3}
                px={3}
                variant="gradient"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h4" color="white" fontWeight="bold">
                  Create Merit List
                </Typography>
              </MDBox>

              <MDBox p={3}>
                <div className="row mt-3">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="campaign">Campaign</label>
                      <Select
                        id="campaign"
                        options={campaigns}
                        getOptionLabel={(e) => e.name}
                        getOptionValue={(e) => e.id}
                        value={campaigns.find((c) => c.id === selectedCampaign)}
                        onChange={(option) => setSelectedCampaign(option?.id)}
                        isSearchable
                        isLoading={campaignsLoading}
                        placeholder="Select Campaign"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                      {errors.campaign && (
                        <div className="text-danger">{errors.campaign}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="department">Department</label>
                      <Select
                        id="department"
                        options={departments}
                        getOptionLabel={(e) => e.name}
                        getOptionValue={(e) => e.id}
                        value={departments.find(
                          (d) => d.id === selectedDepartment
                        )}
                        onChange={handleDepartmentChange}
                        isSearchable
                        isLoading={departmentsLoading}
                        placeholder="Select Department"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                      {errors.department && (
                        <div className="text-danger">{errors.department}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="program">Program</label>
                      <Select
                        id="program"
                        options={programs}
                        getOptionLabel={(e) => e.name}
                        getOptionValue={(e) => e.id}
                        value={programs.find((p) => p.id === selectedProgram)}
                        onChange={handleProgramChange}
                        isSearchable
                        isLoading={programsLoading}
                        placeholder="Select Program"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                      {errors.program && (
                        <div className="text-danger">{errors.program}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="name">Enter Merit List Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Enter Merit List Name"
                      />
                      {errors.name && (
                        <div className="text-danger">{errors.name}</div>
                      )}
                    </div>
                  </div> */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="lastDate">Last Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="lastDate"
                        value={lastDate}
                        onChange={(e) => setLastDate(e.target.value)}
                      />
                      {errors.lastDate && (
                        <div className="text-danger">{errors.lastDate}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="template">Template</label>
                      <Select
                        id="template"
                        options={merit_lists_templates}
                        getOptionLabel={(e) => e.name}
                        getOptionValue={(e) => e.id}
                        value={merit_lists_templates.find(
                          (c) => c.id === selectedTemplate
                        )}
                        onChange={(option) => setSelectedTemplate(option?.id)}
                        isSearchable
                        placeholder="Select Template"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                      {errors.templates && (
                        <div className="text-danger">{errors.templates}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="meritListType">Merit List Type</label>
                      <Select
                        id="meritListType"
                        options={meritListTypes}
                        getOptionLabel={(e) => e.session}
                        getOptionValue={(e) => e.session}
                        value={meritListTypes.find(
                          (m) => m.session === selectedMeritListType
                        )}
                        onChange={(option) => {
                          setSelectedMeritListType(option?.session);
                          setProgramCriteriaId(option?.program_id);
                        }}
                        isSearchable
                        placeholder="Select Merit List Type"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                      {errors.meritListType && (
                        <div className="text-danger">
                          {errors.meritListType}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="multiplier">Multiplier</label>
                      <input
                        name="multiplier"
                        type="number"
                        min="0.1"
                        step="0.1"
                        value={multiplier}
                        onChange={(e) =>
                          setMultiplier(Number.parseFloat(e.target.value) || 1)
                        }
                        className="form-control form-control-lg"
                        placeholder="Enter Multiplier"
                      />
                      {errors.multiplier && (
                        <div className="text-danger">{errors.multiplier}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <FormControl component="fieldset">
                      <FormLabel
                        component="legend"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        Want to Include
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-label="want-to-include"
                        name="wantToInclude"
                        value={wantToInclude}
                        onChange={(e) => setWantToInclude(e.target.value)}
                        style={{ marginTop: "8px" }}
                      >
                        <FormControlLabel
                          value="both"
                          control={<Radio size="small" />}
                          label="Both"
                          style={{ marginRight: "20px" }}
                        />
                        <FormControlLabel
                          value="selected"
                          control={<Radio size="small" />}
                          label="Selected Merit List Type"
                          style={{ marginRight: "20px" }}
                        />
                      </RadioGroup>
                      {errors.wantToInclude && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px", marginTop: "4px" }}
                        >
                          {errors.wantToInclude}
                        </div>
                      )}
                    </FormControl>
                  </div>
                </div>

                {/* Quotas Selection Table */}
                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          marginBottom: "12px",
                          display: "block",
                          color: "#333",
                        }}
                      >
                        Select Quotas ({selectedQuotas.length} selected)
                      </label>

                      {quotasLoading ? (
                        <div className="d-flex justify-content-center align-items-center py-3">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                          <span style={{ marginLeft: "10px", color: "#666" }}>
                            Loading quotas...
                          </span>
                        </div>
                      ) : (
                        <div
                          className="table-responsive"
                          style={{
                            maxHeight: "320px",
                            borderRadius: "12px",
                            boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                            border: "1px solid #e3e6ef",
                            overflowY: "auto",
                            background: "#f6f8fa",
                          }}
                        >
                          <table
                            className="table mb-0"
                            style={{ borderRadius: "12px", overflow: "hidden" }}
                          >
                            <thead
                              style={{
                                background:
                                  "linear-gradient(90deg,#e3e6ef 0%,#f6f8fa 100%)",
                                position: "sticky",
                                top: 0,
                                zIndex: 2,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                              }}
                            >
                              <tr>
                                <th
                                  style={{
                                    width: "50px",
                                    textAlign: "center",
                                    borderRight: "1px solid #e3e6ef",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={areAllQuotasSelected()}
                                    ref={(input) => {
                                      if (input) {
                                        input.indeterminate =
                                          selectedQuotas.length > 0 &&
                                          !areAllQuotasSelected();
                                      }
                                    }}
                                    onChange={(e) =>
                                      handleSelectAllQuotas(e.target.checked)
                                    }
                                  />
                                </th>
                                <th
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    color: "#2d3748",
                                    width: "70px",
                                    textAlign: "center",
                                    borderRight: "1px solid #e3e6ef",
                                  }}
                                >
                                  Sr. No
                                </th>
                                <th
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    color: "#2d3748",
                                    borderRight: "1px solid #e3e6ef",
                                  }}
                                >
                                  Quota Name
                                </th>
                                <th
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    color: "#2d3748",
                                    borderRight: "1px solid #e3e6ef",
                                  }}
                                >
                                  Last Date
                                </th>
                                <th
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    color: "#2d3748",
                                    borderRight: "1px solid #e3e6ef",
                                  }}
                                >
                                  Template
                                </th>
                                <th
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    color: "#2d3748",
                                    borderRight: "1px solid #e3e6ef",
                                  }}
                                >
                                  Merit List Type
                                </th>
                                <th
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    color: "#2d3748",
                                    borderRight: "1px solid #e3e6ef",
                                  }}
                                >
                                  Multiplier
                                </th>
                                <th
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    color: "#2d3748",
                                  }}
                                >
                                  Want to Include
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {quotas.length > 0 ? (
                                quotas.map((quota, index) => (
                                  <tr
                                    key={quota.id}
                                    style={{
                                      backgroundColor: isQuotaSelected(quota.id)
                                        ? "#eaf6ff"
                                        : index % 2 === 0
                                        ? "#fff"
                                        : "#f6f8fa",
                                      transition: "background 0.2s",
                                      borderBottom: "1px solid #e3e6ef",
                                      boxShadow: isQuotaSelected(quota.id)
                                        ? "0 2px 8px rgba(0,123,255,0.08)"
                                        : "none",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.backgroundColor =
                                        "#f0f4fa")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.backgroundColor =
                                        isQuotaSelected(quota.id)
                                          ? "#eaf6ff"
                                          : index % 2 === 0
                                          ? "#fff"
                                          : "#f6f8fa")
                                    }
                                  >
                                    <td
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={isQuotaSelected(quota.id)}
                                        onChange={(e) =>
                                          handleQuotaChange(
                                            quota,
                                            e.target.checked
                                          )
                                        }
                                        style={{ accentColor: "#1976d2" }}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "15px",
                                        fontWeight: "500",
                                        color: "#555",
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {index + 1}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: isQuotaSelected(quota.id)
                                          ? "600"
                                          : "400",
                                        color: "#2d3748",
                                        verticalAlign: "middle",
                                        letterSpacing: "0.2px",
                                      }}
                                    >
                                      {quota.name}
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                      <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={
                                          quotaDetails[quota.id]?.lastDate || ""
                                        }
                                        onChange={(e) =>
                                          handleQuotaFieldChange(
                                            quota.id,
                                            "lastDate",
                                            e.target.value
                                          )
                                        }
                                        disabled={!isQuotaSelected(quota.id)}
                                        style={{
                                          borderRadius: "6px",
                                          border: "1px solid #cfd8dc",
                                          fontSize: "14px",
                                        }}
                                      />
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                      <select
                                        className="form-control form-control-sm"
                                        value={
                                          quotaDetails[quota.id]?.template || ""
                                        }
                                        onChange={(e) =>
                                          handleQuotaFieldChange(
                                            quota.id,
                                            "template",
                                            e.target.value
                                          )
                                        }
                                        disabled={!isQuotaSelected(quota.id)}
                                        style={{
                                          borderRadius: "6px",
                                          border: "1px solid #cfd8dc",
                                          fontSize: "14px",
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {merit_lists_templates.map((t) => (
                                          <option key={t.id} value={t.id}>
                                            {t.name}
                                          </option>
                                        ))}
                                      </select>
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                      <select
                                        className="form-control form-control-sm"
                                        value={
                                          quotaDetails[quota.id]
                                            ?.meritListType || ""
                                        }
                                        onChange={(e) =>
                                          handleQuotaFieldChange(
                                            quota.id,
                                            "meritListType",
                                            e.target.value
                                          )
                                        }
                                        disabled={!isQuotaSelected(quota.id)}
                                        style={{
                                          borderRadius: "6px",
                                          border: "1px solid #cfd8dc",
                                          fontSize: "14px",
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {meritListTypes.map((m) => (
                                          <option
                                            key={m.session}
                                            value={m.session}
                                          >
                                            {m.session}
                                          </option>
                                        ))}
                                      </select>
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                      <input
                                        type="number"
                                        min="0.1"
                                        step="0.1"
                                        className="form-control form-control-sm"
                                        value={
                                          quotaDetails[quota.id]?.multiplier ||
                                          1
                                        }
                                        onChange={(e) =>
                                          handleQuotaFieldChange(
                                            quota.id,
                                            "multiplier",
                                            e.target.value
                                          )
                                        }
                                        disabled={!isQuotaSelected(quota.id)}
                                        style={{
                                          borderRadius: "6px",
                                          border: "1px solid #cfd8dc",
                                          fontSize: "14px",
                                        }}
                                      />
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                      <select
                                        className="form-control form-control-sm"
                                        value={
                                          quotaDetails[quota.id]
                                            ?.wantToInclude || "both"
                                        }
                                        onChange={(e) =>
                                          handleQuotaFieldChange(
                                            quota.id,
                                            "wantToInclude",
                                            e.target.value
                                          )
                                        }
                                        disabled={!isQuotaSelected(quota.id)}
                                        style={{
                                          borderRadius: "6px",
                                          border: "1px solid #cfd8dc",
                                          fontSize: "14px",
                                        }}
                                      >
                                        <option value="both">Both</option>
                                        <option value="selected">
                                          Selected Merit List Type
                                        </option>
                                      </select>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="8"
                                    className="text-center text-muted py-3"
                                  >
                                    No quotas available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {errors.quotas && (
                        <div className="text-danger mt-2">{errors.quotas}</div>
                      )}

                      {selectedQuotas.length > 0 && (
                        <div
                          className="mt-3 p-2"
                          style={{
                            backgroundColor: "#f1f8f1",
                            borderRadius: "6px",
                            border: "1px solid #cdeccd",
                          }}
                        >
                          <strong style={{ color: "#2e7d2e" }}>
                            Selected Quotas:
                          </strong>{" "}
                          <span>
                            {selectedQuotas.map((q) => q.name).join(", ")}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Loading Indicator */}
                {loading && (
                  <div className="row mt-4">
                    <div className="col-md-12">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "20px",
                        }}
                      >
                        <CircularProgress />
                        <Typography
                          variant="body2"
                          style={{ marginLeft: "10px" }}
                        >
                          Generating merit list...
                        </Typography>
                      </div>
                    </div>
                  </div>
                )}

                {/* Generated Merit List Display */}
                {generatedMeritList.length > 0 && (
                  <div className="row mt-4">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-header bg-success text-white">
                          <Typography variant="h6">
                            Generated Merit List ({generatedMeritList.length}{" "}
                            applications)
                          </Typography>
                        </div>
                        <div className="card-body">
                          <div
                            style={{ maxHeight: "400px", overflowY: "auto" }}
                          >
                            <table className="table table-bordered table-striped">
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "white",
                                  zIndex: 1,
                                }}
                              >
                                <tr>
                                  <th>Sr.No</th>
                                  <th>Application ID</th>
                                  <th>Name</th>
                                  <th>CNIC</th>
                                  <th>Father Name</th>
                                  <th>Aggregate</th>
                                </tr>
                              </thead>
                              <tbody>
                                {generatedMeritList.map((item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.application_form_id}</td>
                                    <td>{item.name}</td>
                                    <td>{item.cnic}</td>
                                    <td>{item.father_name}</td>
                                    <td>{item.aggregate.toFixed(2)}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* Action Buttons */}
      <div className="row mt-4">
        <div className="col-md-12">
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleReset}
              className="dialog-actions-button negative"
              disabled={loading || saveLoading}
              style={{
                minWidth: "120px",
                fontSize: "15px",
                borderRadius: "8px",
              }}
            >
              Reset
            </Button>
            {generatedMeritList.length <= 0 && (
              <Button
                variant="contained"
                onClick={handleGenerateMeritList}
                disabled={loading}
                style={{
                  minWidth: "150px",
                  color: "white",
                  fontSize: "15px",
                  borderRadius: "8px",
                }}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Generate Merit List"
                )}
              </Button>
            )}
            {generatedMeritList.length > 0 && (
              <Button
                variant="contained"
                color="success"
                onClick={handleSave}
                disabled={saveLoading}
                style={{
                  minWidth: "120px",
                  fontSize: "15px",
                  borderRadius: "8px",
                }}
              >
                {saveLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save Merit List"
                )}
              </Button>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default BulkMeritList;
